<template>
  <div class="h-100 w-100 d-flex flex-column overflow-y-scroll custom-scroll">
    <!-- Zona de selección -->
    <div class="d-flex flex-column flex-grow-1 justify-content-center align-items-center">
      <h4
        class="text-center fw-bold"
        style="color: #011638;"
      >
        ¿Buscas o tienes garaje?
      </h4>
      <p
        class="text-center fw-semibold mb-4"
        style="color: #011638;"
      >
        Elige tu perfil
      </p>
      <div>
        <a
          href="/create-driver"
          class="text-decoration-none mb-3 rounded-4 px-5 bg-white d-flex flex-column justify-content-center align-items-center"
          style="aspect-ratio: 1 / 1; max-width: 250px !important;"
        >
          <img
            src="../assets/driver_icon2.png"
            style="width: 70px; height: 70px;"
          >
          <p
            class="mt-3 mb-1 fw-bold text-center"
            style="color: #011638; font-size: 1.1rem;"
          >
            Soy Driver
          </p>
          <p class="mb-0 text-center">
            Busco garaje
          </p>
        </a>
        <a
          href="/create-parker"
          class="text-decoration-none mb-3 rounded-4 px-5 bg-white d-flex flex-column justify-content-center align-items-center"
          style="aspect-ratio: 1 / 1; max-width: 250px !important;"
        >
          <img
            src="../assets/parker_icon2.png"
            style="width: 70px; height: 70px;"
          >
          <p
            class="mt-3 mb-1 fw-bold text-center"
            style="color: #011638; font-size: 1.1rem;"
          >
            Soy Parker
          </p>
          <p class="mb-0 text-center">Tengo garaje</p>
        </a>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import mixpanel from 'mixpanel-browser';
import router from '@/router';

export default {
  name: 'HomeA',
  components: {
  },
  data: function() {
        return {
        }
    },
  computed:{
      ...mapState(['token']),
  },
  mounted(){
    mixpanel.track('app.parkiduo.com_visits', {
      pantalla: 'Home'
    });
  },
  methods: {
    goToParker(){
      mixpanel.track('apphome_click_soy parker', {
        pantalla: 'Home'
      });
      router.push({ name: "create-parker" });
    },
    goToDriver(){
      mixpanel.track('apphome_click_soy driver', {
        pantalla: 'Home'
      });
      router.push({ name: "create-driver" });
    }
  }
}
</script>

<style scoped>

</style>
